import { useRef, useState } from "react";
import { http, apiError, API } from "@/lib/api";
import { toast } from "sonner";
import { UploadCloud, Download, Loader2 } from "lucide-react";

export default function UploadBox({ endpoint, templateKind, onDone, testId = "upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await http.post(endpoint, fd);
      toast.success(`Berhasil menyimpan ${data.saved} dari ${data.total_rows} baris`);
      onDone?.();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const downloadTemplate = async () => {
    try {
      const res = await http.get(`/template/${templateKind}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `template_${templateKind}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Gagal mengunduh template");
    }
  };

  return (
    <div className="erp-panel p-5" data-testid={`${testId}-box`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <div className="mono text-[11px] uppercase tracking-widest text-[#525252]">
            Upload File Excel
          </div>
          <p className="text-sm text-[#525252] mt-1">
            Data akan otomatis tersimpan sesuai kolom template. Baris tanpa Kode
            Stock akan dilewati.
          </p>
        </div>
        <div className="flex gap-2">
          <button
            data-testid={`${testId}-template-button`}
            onClick={downloadTemplate}
            className="h-10 px-3 border border-neutral-800 text-xs uppercase tracking-wide flex items-center gap-2 hover:bg-neutral-900 hover:text-white transition-colors"
          >
            <Download className="h-3.5 w-3.5" /> Template
          </button>
          <button
            data-testid={`${testId}-file-button`}
            disabled={busy}
            onClick={() => ref.current?.click()}
            className="h-10 px-4 bg-[#4338CA] text-white text-xs uppercase tracking-wide flex items-center gap-2 hover:bg-[#3730A3] transition-colors disabled:opacity-60"
          >
            {busy ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <UploadCloud className="h-3.5 w-3.5" />
            )}
            Pilih File
          </button>
          <input
            ref={ref}
            data-testid={`${testId}-file-input`}
            type="file"
            accept=".xlsx,.xls"
            className="hidden"
            onChange={(e) => send(e.target.files?.[0])}
          />
        </div>
      </div>
    </div>
  );
}
